import { render, staticRenderFns } from "./CampaignEditor.vue?vue&type=template&id=f1daee56&"
import script from "./CampaignEditor.vue?vue&type=script&lang=js&"
export * from "./CampaignEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports